/* eslint-disable @typescript-eslint/no-invalid-void-type */
import { Options } from '../options.interface';
import { HttpClient } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { buildUrl } from '@wizbii-utils/angular/core';
import { Company, Recruiter } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

export interface CompanyApiConfig {
  baseUrl: string;
}

export const COMPANY_API_CONFIG = new InjectionToken<CompanyApiConfig>('COMPANY_API_CONFIG');

@Injectable()
export class CompanyWebservice {
  readonly #http = inject(HttpClient);
  readonly #companyApiConfig = inject(COMPANY_API_CONFIG);

  readonly #baseUrl = this.#companyApiConfig.baseUrl;

  /**
   * Get a Wizbii company
   * @param {string} id Id of the company
   * @param {Object} [options] Angular Options for the request
   */
  get(id: string, options?: Options): Observable<Company> {
    return this.#http.get<Company>(buildUrl(`${this.#baseUrl}/v1/company/:id`, { id }), options);
  }

  /**
   * Get a Wizbii company in admin format
   * @param {string} id Id of the company
   * @param {Object} [options] Angular Options for the request
   */
  adminGet(id: string, options?: Options): Observable<Company> {
    return this.#http.get<Company>(buildUrl(`${this.#baseUrl}/v1/admin/company/:id`, { id }), options);
  }

  /**
   * Update a Wizbii company
   * @param {string} id id of company to update
   * @param {Company} company Company to update
   * @param {Object} [options] Angular Options for the request
   */
  updateCompany(id: string, company: Company, options?: Options): Observable<Company> {
    return this.#http.put<Company>(`${this.#baseUrl}/v1/admin/company/${id}`, company, options);
  }

  getRecruiter(recruiterId: string): Observable<Recruiter> {
    return this.#http.get<Recruiter>(`${this.#baseUrl}/v1/recruiter/${recruiterId}`);
  }

  updateRecruiter(recruiter: Recruiter, options?: Options): Observable<Recruiter> {
    return this.#http.put<Recruiter>(`${this.#baseUrl}/v1/recruiter/${recruiter.id}`, recruiter, options);
  }

  createRecruiter(recruiter: Recruiter): Observable<Recruiter> {
    return this.#http.post<Recruiter>(`${this.#baseUrl}/v1/recruiter`, recruiter);
  }

  deleteRecruiter(recruiterId: string): Observable<void> {
    return this.#http.delete<void>(`${this.#baseUrl}/v1/recruiter/${recruiterId}`);
  }
}
